import HighlighterWrapper from '@components/highlighterWrapper/HighlighterWrapper';
import React, {useCallback, useEffect, useState} from 'react';
import {useLocation} from 'react-router-dom';
import {SEARCH_CONTEXT} from 'src/routes/BaseRoute';
import EncryptUtils from 'src/utils/EncryptUtils';

interface TextViewerProps {
  base64?: string;
  string?: string;
}

const TextViewer: React.FC<TextViewerProps> = ({base64, string}) => {
  const [dimensions, setDimensions] = useState<any>({
    width: 5000,
    height: 5000
  });
  const location = useLocation();
  const normalizedContent = string?.replace(/\r\n?/g, '\n') ?? '';

  const searchContext = EncryptUtils.getDecryptedData(
    location?.search,
    SEARCH_CONTEXT
  );

  const findMaxLengthOfLine = useCallback(
    (content: string): any => {
      const lines = content.split('\n');
      let maxLength = 0;
      lines.forEach(line => {
        if (line.length > maxLength) {
          maxLength = line.length;
        }
      });
      if (dimensions?.width > maxLength) {
        setDimensions((prevState: any) => ({
          ...prevState,
          height: lines?.length * 5 * (window.innerHeight / 100),
          width: maxLength * (window.innerWidth / 150)
        }));
      }
    },
    [dimensions?.width]
  );

  useEffect(() => {
    if (normalizedContent.length) findMaxLengthOfLine(normalizedContent);
  }, [normalizedContent, findMaxLengthOfLine]);

  return (
    <HighlighterWrapper keywords={[searchContext]}>
      <div
        style={{
          height: dimensions?.height + 'px',
          width: dimensions?.width + 'px',
          whiteSpace: 'pre-wrap'
        }}>
        <pre>{normalizedContent}</pre>
      </div>
    </HighlighterWrapper>
  );
};

export default TextViewer;
